import React from "react";
import { Container } from "reactstrap";
import ProductCard from "views/edge-pages/ProductCard.js";
import { APPS } from "data/apps.js";

function OurProducts() {
  const products = APPS.filter((a) => !a.comingSoon);

  return (
    <section className="edge-clients-section" id="products">
      <Container>
        <span className="edge-section-eyebrow">{"// OUR PRODUCTS"}</span>
        <h2 className="edge-section-heading">
          Apps &amp; tools<br />
          <span className="muted">we built</span>
        </h2>
        <p className="edge-section-sub">
          Real products from Edge Ventures — from AI-powered mobile apps to developer utilities.
        </p>

        <div className="products-hub-grid">
          {products.map((app) => (
            <ProductCard key={app.slug} app={app} />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default OurProducts;
